import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface StepCardProps {
  step: number;
  title: string;
  description: string;
  icon: LucideIcon;
  className?: string;
}

export function StepCard({ step, title, description, icon: Icon, className }: StepCardProps) {
  return (
    <div className={cn('group/step relative', className)}>
      {/* Step Number */}
      <div className="absolute -left-1 -top-3 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-kuiva-blue to-kuiva-green text-xs font-bold text-white shadow-md ring-2 ring-white/90 transition-[transform,box-shadow] duration-500 ease-kuiva group-hover/step:scale-110 group-hover/step:shadow-lg sm:h-8 sm:w-8 sm:text-sm">
        {step}
      </div>

      <div className="card-kuiva pt-6 sm:pt-7">
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-kuiva-blue/20 to-kuiva-green/20 sm:mb-3 sm:h-14 sm:w-14 sm:rounded-2xl">
          <Icon className="h-6 w-6 text-kuiva-blue sm:h-7 sm:w-7" />
        </div>
        <h3 className="mb-1 text-sm font-semibold text-foreground sm:text-base">{title}</h3>
        <p className="text-xs leading-relaxed text-muted-foreground sm:text-sm">{description}</p>
      </div>
    </div>
  );
}
